import { mergeSx } from "@/utils";

import { SvgIcon } from "@/components/SvgIcon";
import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

export function CoinbaseSymbol({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("CoinbaseSymbol");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 48 48"
      sx={mergeSx({ w: "100px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

CoinbaseSymbol.displayName = "CoinbaseSymbol";
